// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__TMXxl","ssr-layout":"styles_ssr-layout__35qtf","footerLinks":"styles_footerLinks__965zD","footerTextStyling":"styles_footerTextStyling__IQb27"};